module.exports = __webpack_public_path__ + "img/waternormals-min.5fccd1e1.jpg";